// How far a role reaches, as a translation key.
//
// Lives here rather than in either page that draws it. `/dev-login` carries a
// guard (`DevLoginPage.spec.tsx`, finding D-15) that fails the build if that
// file contains a role-code literal at all: the page and
// `frontoffice-e2e/_helpers/mpass-fixtures.ts` once kept separate persona lists
// that disagreed on two roles, and the guard is what stops either growing its
// own again. A local `scopeKeyFor` in the page would trip it — correctly — so
// the codes live on this side of the line and both screens import them.
//
// caiet §2 role table: the reach is a property of the role code, so it is
// knowable from the session alone and costs no extra request. The three buckets
// are the ones the 2026-08-30 audit names.
export function scopeKeyFor(role: string): string {
  if (role === 'REGISTRAR_ADMIN') return 'role_select.scope.registrar';
  if (role === 'REGISTRAR_OPERATOR') return 'role_select.scope.location';
  return 'role_select.scope.global';
}
